import dashboard from './dashboard';
import trade from './trade';
import options from './options';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: []
};

if (dashboard.children.length > 0) menuItems.items.push(dashboard);
if (trade.children.length > 0) menuItems.items.push(trade);
if (options.children.length > 0) menuItems.items.push(options);

export default menuItems;
